<template>
  <div class="container-input">
    <input
      v-model="input"
      v-bind="$attrs"
      :maxlength="maxLength"
      :class="['form-control', ...classNames]"
      @keyup.enter="handleEnter"
      @change="handleChange"
    >
    <div
      v-if="invalidText"
      class="invalid-feedback">
      {{ invalidText }}
    </div>
    <div
      v-if="validText"
      class="valid-feedback">
      {{ validText }}
    </div>
    <span
      v-if="showClearButton"
      class="close-btn"
      @click="onClear"
    >
      <i class="fas fa-times"/>
    </span>
  </div>
</template>

<script>
export default {
  name: 'BaseInput',

  inheritAttrs: false,

  props: {
    value: {
      default: null,
    },
    clear: {
      type: Boolean,
      default: false,
    },
    classNames: {
      type: Array,
      default: () => ([]),
    },
    invalidText: String,
    validText: String,
    maxLength: Number,
  },

  data () {
    return {
      input: null,
    }
  },

  computed: {
    showClearButton () {
      return this.clear && this.input
    },
  },

  watch: {
    input (newVal) {
      this.$emit('input', newVal)
    },
    value (newVal) {
      this.input = newVal
    },
  },

  mounted () {
    this.input = this.value
  },

  methods: {
    handleEnter (e) {
      this.$emit('onEnter', e)
    },
    onClear (e) {
      this.input = ''
      this.$nextTick(() => {
        this.$emit('onClear', e)
      })
    },
    handleChange (e) {
      this.$emit('change', e)
    },
  },
}
</script>

<style scoped>
  .container-input {
    position: relative;
    width: 100%;
    padding: 0;
  }

  .close-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 100%;
    color: #6C7A86;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/base/BaseInput.vue